export default __webpack_public_path__ + "static/daylon-bitmoji-b247fa7b03e727ff63111b08b2edd139.png";